import React, { useState } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { createCustomer } from "../../services/customerService";

const CreateCustomerModal = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const currentUserId = localStorage.getItem("userId");
      const customerData = {
        ...values,
        createdByUserId: currentUserId
      };

      await createCustomer(customerData);
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (error.errorFields) {
        // Form validation error
      } else {
        message.error("Failed to create customer");
        console.error("Error creating customer:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Yeni Müşteri Oluştur"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          İptal
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Oluştur
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          companyName: "",
          email: "",
          password: "",
          phone: "",
          contactPerson: "",
        }}
      >
        <Form.Item
          name="companyName"
          label="Müşteri Adı"
          rules={[
            { required: true, message: "Müşteri adı zorunludur" },
            { max: 100, message: "Müşteri ismi 100 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Email zorunludur" },
            { type: "email", message: "Email formatı yanlış" },
            { max: 100, message: "Email 100 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="password"
          label="Şifre"
          rules={[{ required: true, message: "Şifre zorunludur" }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Numara"
          rules={[
            {
              pattern: /^0\d{3} \d{3} \d{4}$/,
              message: "Numara 0XXX XXX XXXX formatında olmalı",
            },
          ]}
        >
          <Input
            placeholder="0XXX XXX XXXX"
            maxLength={13}
            onKeyPress={(e) => {
              const allowedChars = /[0-9 ]/;
              if (!allowedChars.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="contactPerson"
          label="İlgili Kişi"
          rules={[
            { max: 100, message: "İlgili kişi alanı 100 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateCustomerModal;
